import en from 'vuetify/lib/locale/en'

export default {
    ...en,
    add: 'Add',
    addAlternateEmail: 'Add alternate e-mail',
    addAlternateEmailxs: 'Alternate e-mail',
    addAlternatePhone: 'Add alternate phone',
    addAlternatePhonexs: 'Alt. ph.',
    cancel: 'Cancel',
    change: 'Change',
    changePassword: 'Change password',
    chooseRegisteredPhone: 'Or choose registered phone',
    countryCode: 'Country code',
    createAccount: 'Create account',
    emailLoginLabel: 'E-mail',
    extension: 'Extension',
    forgotPass: 'Recover password',
    forgotPassBtn: 'Send',
    forgotPassLink: 'Forgot password?',
    help: 'Help',
    lastUpdate: 'Last update',
    logout: 'Logout',
    name: 'Name',
    newPassword: 'New password',
    oldPassword: 'Old password',
    passLoginLabel: 'Password',
    password: 'Password',
    passwordExpirationDate: 'Password expiration date',
    phone: 'Phone',
    primaryEmail: 'Primary e-mail',
    primaryPhone: 'Primary phone',
    register: 'Register',
    remove: 'Remove',
    returnToLogin: 'Return to login',
    save: 'Save',
    saveChanges: 'Save changes',
    selectLocale: 'Select a language',
    signIn: 'Login',
    signInBtn: 'Sign In',
    smsCellphone: 'Fill SMS cellphone',
    smsCellphonexs: 'SMS cellphone',
    userInformation: 'User information',
    userInformationxs: 'Profile',
}
